import React from 'react'
import AddModel from '../../pages/addModel'
import ButtonComp from '../button/ButtonComp'
import { Popconfirm, Button } from 'antd'
import {
    DeleteOutlined,
} from "@ant-design/icons";
import { useSelector } from 'react-redux';

const DepartmentPage = ({
    company,
    isModalOpen,
    showModal,
    handleCancelModal,
    handleDepartment,
    deleteDepartment,
    addDepartmentFrom,
}) => {
    const select = useSelector((state) => state.auth);
    const user_role = select.userInfo.role;
    return (
        <div>
            <div className=" text-black pb-3 px-2 flex items-center justify-between">
                <span>
                    <h1 className="font-semibold text-[15px] pt-[1%] dark:text-white">
                        Departments
                    </h1>
                </span>

                {(user_role && user_role.toLowerCase() === "admin") ||
                    user_role.toLowerCase() === "superadmin" ? (
                    <>
                        <ButtonComp
                            text="Add Departments"
                            bgColor="#4E36A3"
                            textColor="white"
                            onClick={showModal}
                        />
                    </>
                ) : (
                    ""
                )}
            </div>
            {company.department_list &&
                company.department_list.map((department, index) => (
                    <>
                        <div className="bg-purple-50 py-2 px-5 mb-3">
                            <h1
                                key={department.id}
                                value={department.id}
                                className="mt-1"
                            >
                                <div className="delete_department">
                                    <span className="text-[12px] font-[500]">{department}</span>
                                    {(user_role &&
                                        user_role.toLowerCase() === "admin") ||
                                        user_role.toLowerCase() === "superadmin" ? (
                                        <span>
                                            <Popconfirm
                                                title="Delete Department"
                                                description="Are you sure to delete this department?"
                                                okText="Yes"
                                                cancelText="No"
                                                onConfirm={() =>
                                                    deleteDepartment(department)
                                                }
                                                placement="bottomLeft"
                                            >
                                                <Button danger>
                                                    <DeleteOutlined className="" />
                                                </Button>
                                            </Popconfirm>
                                        </span>
                                    ) : (
                                        ""
                                    )}
                                </div>
                            </h1>
                        </div>
                    </>
                ))}
            <AddModel title='Department Name' isOpen={isModalOpen} handleCancelModal={handleCancelModal}
                from={addDepartmentFrom} name={['dynamic_form_item', 'department_list']} onFinish={handleDepartment} />

        </div>
    )
}

export default DepartmentPage
